import React from "react";

function createContext({ name }) {
  const Ctx = React.createContext();

  Ctx.displayName = name;

  const useCtx = () => React.useContext(Ctx);

  return [Ctx.Provider, useCtx, Ctx];
}

export default createContext;
